import api from 'skin/http';

//Получение адреса компании
function findAddress(v, signal) {
	return new Promise((resolve, reject) => {
		v = encodeURI(v)
		const opt = {
			method: 'GET',
			signal,
			url: 'api/other/signup/address',
			params: {
				val: v
			},
			headers: {
				nowait: true
			}
		}
		api(opt)
			.then(r => {
				const a = r.data?.suggestions || []
				resolve(a);
			})
			.catch(err => {
				console.log('err', err);
				reject(err);
			})
	})
}

export default findAddress